import { IState } from "Model/State/IState";
import { isNotNullOrWhiteSpace } from "Utils/String";

export function selectAuthenticationToken(state: IState): string {
  return state.authorization;
}

export function selectIsAuthenticated(state: IState): boolean {
  return isNotNullOrWhiteSpace(selectAuthenticationToken(state));
}
